import { z } from "zod"

export const ShareContactSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("email"),
        email: z.string(),
        phoneNumber: z.undefined().optional(),
    }),
    z.object({
        type: z.literal("phone"),
        email: z.undefined().optional(),
        phoneNumber: z.string(),
    }),
])

export const missionGroupIcons = [
    "contactEmergency",
    "directionsRun",
    "e911Emergency",
    "localFireDepartment",
    "fireTruck",
    "domain",
    "adminPanelSettings",
    "localPolice",
    "emergency",
    "healthCross",
] as const

export const missionGroupColors = [
    "#7C7870", // group-palette-grey
    "#3F7286", // group-palette-blue
    "#4A714B", // group-palette-green
    "#A97534", // group-palette-orange
    "#AA493C", // group-palette-red
] as const

export const MissionGroupIconSchema = z.enum(missionGroupIcons)
export const MissionGroupColorSchema = z.enum(missionGroupColors)

export type MissionGroupIcon = z.infer<typeof MissionGroupIconSchema>
export type MissionGroupColor = z.infer<typeof MissionGroupColorSchema>

export const ContactListSchema = z.object({
    id: z.string(),
    name: z.string(),
    contacts: z.array(ShareContactSchema),
    icon: MissionGroupIconSchema.optional(),
    color: MissionGroupColorSchema.optional(),
    autoNotify: z.boolean().optional(),
    passwordEnabled: z.boolean().optional(),
    password: z.string().optional(),
})

export type ShareContact = z.infer<typeof ShareContactSchema>
export type ContactList = z.infer<typeof ContactListSchema>
